<template>
  <div class="h-full">
    <div class="h-full pb-10 px-4">
      <pie-chart class="pb-3" @loaded="checkLoaded($event)" :source="source" :update="update" :colorPalette="colorPalette" :deliveryType="source === '/stats/sale/delivery-type'"></pie-chart>
    </div>
<!--    <div v-if="!loaded" class="h-full  flex justify-center">-->
<!--      <p class="self-center px-4 -mt-10 text-center">{{ $t('widget.noData') }}</p>-->
<!--    </div>-->
  </div>
</template>

<script setup>
import { defineProps, defineEmits} from "vue";
import PieChart from "@/widgetContent/charts/PieChart";
const emit = defineEmits(["dataLoaded","dataUnloaded"])

defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
function checkLoaded(e){
  if (e){
    emit("dataLoaded")
  }else {
    emit("dataUnloaded")
  }
}
</script>

